<template>
  <div class="pages depart_list">
    <el-container>
      <el-header style="height:40px;">
        <h3 class="pageTitle">Department List</h3>
      </el-header>
      <el-container class="main-content">
        <el-aside style="width:250px;">
          <el-card class="silder">
            <el-tree :data="treeData"
                     v-loading="loading"
                     class="departList"
                     node-key="id"
                     :defaultExpandedKeys="defaultKey"
                     :props="props"
                     @node-click="handleNodeClick"></el-tree>
          </el-card>
        </el-aside>
        <el-container>
          <el-card class="content">
            <div slot="header"
                 class=" r-header">
              <div class="r-title">{{ current && current.name_path }} Infomation</div>
              <!-- <div class="del"
                   @click="delDept">Delete</div> -->
            </div>
            <el-form ref="form"
                     :model="form"
                     label-width="80px"
                     :label-position="labelPosition"
                     class="depInfo">
              <el-form-item :label="$t('memberlist.duty_account')"
                            prop="job_id"
                            class="formItem">
                <div v-if="editing">
                  <el-select v-model="form.duty_account"
                             style="width: 100%;"
                             :placeholder="$t('memberlist.p_select')"
                             filterable
                             remote
                             clearable
                             :remote-method="remoteMethod"
                             :loading="remoteLoading"
                             no-match-text="没有匹配到数据"
                             :disabled="edit">
                    <el-option v-for="item in options"
                               :key="item.account"
                               :label="item.account"
                               :value="item.account">
                    </el-option>
                  </el-select>
                </div>
                <span v-else>{{ form.duty_account || '--' }}</span>

              </el-form-item>
              <el-form-item class="formLeftZero">
                <el-button class="btn"
                           v-show="editing"
                           @click="handleClickone">Cancel</el-button>
                <el-button class="btn"
                           type="primary"
                           @click="handleClicktwo">{{ !editing? 'Modify' : 'Save'}}</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-container>
      </el-container>
    </el-container>
    <my-dialog :myVisible="addDept"
               @changes="changes"
               @dialogSure="dialogSure"
               :title="title"
               :myWidth="`40%`">
      <template v-slot:content>
        <el-form ref="addDeptForm"
                 :model="addDeptForm"
                 label-width="100px"
                 :label-position="labelPosition"
                 v-show="jugeType(1,type)"
                 class="depInfo">
          <el-form-item label="Dept Name: "
                        :rules="rules.name"
                        prop="name">
            <el-input v-model="addDeptForm.name"></el-input>
          </el-form-item>
          <el-form-item label="Supervisor: ">
            <span>{{ current.name }}</span>
          </el-form-item>
        </el-form>
        <p v-show="jugeType(2,type)"
           v-html="deleteMsg"
           class="dialogLine"></p>
      </template>
    </my-dialog>
    <my-dialog :myVisible="delDialog"
               @changes="delChanges"
               @dialogSure="delConfirm"
               :title="title">
      <template v-slot:content>
        <p class="delmsg dialogLine">Delete {{current.name}} department?</p>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import {
  getDepart,
  depAdd,
  depDel,
  deletable,
  // depModify,
  modifyDutyAccount,
  searchByAccount
} from "@/api/api.js";
import myDialog from "@/components/myDialog.vue";
import _ from "lodash";

export default {
  name: "departList",
  components: { myDialog },
  data() {
    return {
      treeData: [],
      loading: false,
      props: {
        label: "name",
        children: "child_list"
      },
      current: {},
      labelPosition: "left",
      editing: false,
      addDept: false,
      title: "",
      type: 1, // 弹框内容分类
      newDeptName: "", // 新增部门名
      rules: {
        name: [
          {
            required: true,
            message: "Please enter a new department name",
            trigger: "blur"
          },
          {
            min: 1,
            max: 30,
            message: "Length should be 1 to 30",
            trigger: "blur"
          }
        ]
      },
      deleteMsg: "",
      isBlur: false,
      delDialog: false,
      defaultKey: [],
      departments: [],
      supervisor: "",
      addDeptForm: {
        name: ""
      },
      form: {},
      remoteLoading: false,
      keyWord: "",
      options: []
    };
  },
  methods: {
    remoteMethod(searchKey) {
      //输入值发生变化时的回调函数
      if (searchKey !== "") {
        this.remoteLoading = true;
        this.keyWord = searchKey;
        this.getRemote();
      } else {
        this.options = [];
      }
    },
    getRemote: _.debounce(function () {
      //防抖，这里设置300毫秒请求一次后台
      console.log(this.keyWord);
      this.searchByAccount({
        keyword: this.keyWord
      });
    }, 300),
    async searchByAccount(params) {
      let res = await searchByAccount(params);
      this.remoteLoading = false;
      this.options = res?.list.map((item) => ({
        account: item.account,
        username: `${item.username}(${item.account})`
      }));
    },
    handleChanged(data) {
      this.isBlur = true;
      this.form.supervisor_id = data[0] && data[0].id;
      this.form.supervisor_name = data[0] && data[0].name;
    },
    getArrays(datas) {
      //遍历树
      let arr = datas;
      for (var i in arr) {
        arr[i].children = arr[i].child_list;
        if (arr[i].child_list.length) {
          this.getArrays(arr[i].child_list);
        }
      }
      this.departments = arr;
    },
    async getDep() {
      this.loading = true;
      const data = await getDepart();
      this.treeData = data;
      this.loading = false;
      if (!this.form.id) {
        !this.defaultKey.length && this.defaultKey.push(data[0].id);
        !this.current.id && (this.current = data[0]);
        this.form = JSON.parse(JSON.stringify(data[0]));
      }
      this.getArrays(data);
    },
    handleNodeClick(data) {
      this.current = data;
      this.defaultKey = [data.id];
      this.form = JSON.parse(JSON.stringify(data));
      this.supervisor = data.parent_name;
      console.log(this.form);
    },
    // 按钮1
    handleClickone() {
      if (!this.editing) {
        this.addDept = true;
        this.title = "New Department";
      } else {
        this.editing = !this.editing;
        this.form.name = this.current.name;
      }
      this.isBlur = false;
      this.type = 1;
    },
    async handleClicktwo() {
      if (this.editing) {
        let params = {
          id: this.form.id,
          duty_account: this.form.duty_account
        };
        await modifyDutyAccount(params)
          .then(() => {
            // this.supervisor = this.form.supervisor_name || this.form.parent_name;
            // this.isBlur = false;
            this.$message({
              message: `Department Supervisor Modify successfully`,
              type: "success"
            });
            this.getDep();
          })
          .catch(() => {
            this.isBlur = false;
            this.editing = false;
          });
      }
      this.editing = !this.editing;
    },
    async delDept() {
      if (!this.current.id) {
        return false;
      }
      let data = {};
      try {
        data = await deletable({ id: this.current.id });
      } catch (error) {
        // error == res.ret
        return false;
      }

      if (data.deletable !== 1) {
        this.addDept = true;
        this.type = 2;
        this.deleteMsg = `Delete members or sub-departments under this department before deleting the department`;
        this.title = "Delete Department";
      } else {
        this.delDialog = true;
      }
    },
    changes(val) {
      this.$refs.addDeptForm.resetFields();
      this.addDept = val;
    },
    delChanges(val) {
      this.delDialog = val;
    },
    dialogSure() {
      this.type === 2 && (this.addDept = false);
      this.type === 1 && this.addNewDept();
    },
    jugeType(curretType) {
      return curretType === this.type;
    },
    addNewDept() {
      let params = { ...this.addDeptForm };
      params.supervisor_id = this.current.id;
      console.log(params);
      this.$refs["addDeptForm"].validate(async (valid) => {
        if (valid) {
          try {
            await depAdd(params);
            this.$message({
              message: `Department added successfully`,
              type: "success"
            });
            this.getDep();
          } catch (error) {
            console.log(error);
          }
          this.$refs.addDeptForm.resetFields();
          this.addDept = false;
        }
      });
    },
    // 确认删除
    async delConfirm() {
      try {
        await depDel({ id: this.current.id });
        this.$message({
          message: `Department deleted successfully`,
          type: "success"
        });
      } catch (error) {
        console.log(error);
      }
      this.delDialog = false;
      this.getDep();
    }
  },
  computed: {
    // supervisor: {
    //   get: function (val) {
    //     console.log(val);
    //     let arr = this.current.name_path && this.current.name_path.split("/");
    //     let data = arr && arr[arr.length - 2];
    //     return data || "";
    //   }
    // },
  },
  mounted() {
    this.getDep();
    console.log(this.defaultKey);
    this.ucWatermark();
  }
};
</script>
<style lang="less">
.silder {
  padding: 10px;
  .el-card__body {
    padding: 0;
    width: 100%;
    height: 100%;
    .departList {
      width: 100%;
      height: 100%;
      overflow: auto;
      .el-tree-node > .el-tree-node__children {
        overflow: visible;
      }
    }
  }
}
.formLeftZero {
  .el-form-item__content {
    margin-left: 0px !important;
  }
}
.depart_list {
  .el-form-item__label {
    width: 180px !important;
    float: left;
  }
  .el-form-item__content {
    margin-left: 20px !important;
    width: 300px !important;
    float: left;
  }
}
</style>
<style lang="less" scoped>
.depart_list {
  .el-input,
  .el-select,
  .wl-tree-select {
    width: 240px;
  }
  .el-header {
    padding: 0;
  }
  .el-container {
    height: 100%;
  }
  h4 {
    text-indent: 20px;
  }
  .main-content {
    margin: 30px 20px 0;
    height: calc(100vh - 300px);
  }
  .silder {
    max-width: 250px;
    height: 100%;
    box-sizing: border-box;
    margin-right: 20px;
    .el-tree {
      width: 200px;
    }
  }
  .content {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  }
  .r-header {
    display: flex;
    justify-content: space-between;
    .r-title {
      font-weight: 800;
    }
    .del {
      text-align: right;
      cursor: pointer;
      color: #409eff;
      font-weight: 800;
    }
  }
  .depInfo {
    width: 100%;
    margin: 0 auto;
    .btn {
      min-width: 80px;
    }
  }
  .dialogLine {
    font-size: 16px;
    line-height: 25px;
  }
  .delmsg {
    text-align: center;
  }
}
</style>
